const urls = {
  auth0: {
    api: {
      user: () => `/user`,
      userPassword: () => `/user/password`,
      userPasswordReset: () => `/user/password/reset`,
      passwordPolicy: () => "/configuration/password-policy",
    },
  },
};
export default urls;
